// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__K-jQ-","messages":"Chat_messages__NpzAG","dateDivider":"Chat_dateDivider__2znBn"};